import React, { useState } from 'react';
import { Card, Button, Tooltip, Typography, Space, Row, Col, message, Spin, Skeleton } from 'antd';
import { CloseCircleOutlined, CloseOutlined, SoundOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axiosInstance from '../services/axiosInstance';
import { catchError } from '../utils/errorHandler';
import commonService from '../services/commonService';
import { setUpdateList } from '../redux/slices/newUpdateSlice';

const { Text } = Typography;

const GlobalUpdateNotifier = () => {
  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const updateList = useSelector((state) => state?.newUpdate?.updateList?.active);
  const [loading, setLoading] = useState(false)

  const handleDismissAll = async (uids) => {
    setLoading(true)
    try {
      const payload = {
        update_uids: []
      };

      uids.forEach((uid) => {
        payload.update_uids.push(uid);
      });

      const response = await axiosInstance.post('/notifications/v2/updates/dismiss/', payload);
      if (response?.status) {

        const updatedResponse = await commonService.getCommonInfo();
        if (updatedResponse.success) {
          const { update_notifications } = updatedResponse.data.data;
          dispatch(setUpdateList(update_notifications));
          navigate('/help-center');
          setLoading(false)
        }
      }
    } catch (err) {
      await catchError(err);
      setLoading(false)
    }

    // Hide the notification once dismissed
    setVisible(false);
  };

  const handleToggleCardView = () => {
    setVisible(!visible)
  }

  if (!updateList?.length) return null;
  const allUids = updateList.map((item) => item.uid);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 48,
        right: 24,
        left: 'auto',
        zIndex: 1000,
        maxWidth: 420,
        width: '90vw',
        animation: 'fadeInUp 0.4s ease-out',
      }}
    >
      <style>
        {`
          @keyframes fadeInUp {
            from {
              transform: translateY(20px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
        `}
      </style>

      {visible && (
        loading ? (
          <div style={{
            display: 'flex',
            justifyContent: "flex-end",
          }}>
            <div
              style={{
                width: "200px",
                gap: '12px',
                padding: '10px 20px',
                background: 'linear-gradient(135deg, #36c6d3, #43e97b)',
                borderRadius: 16,
                boxShadow: '0 8px 20px rgba(54, 198, 211, 0.35)',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Skeleton.Avatar active size="default" shape="square" style={{ backgroundColor: '#ffffff33' }} />
                <Skeleton.Button active size="default" shape="square" style={{ backgroundColor: '#ffffff33' }} />
              </div>

              <div style={{ width: '100%', height: 1, background: 'rgba(255, 255, 255, 0.4)', margin: '10px 0' }} />

              <Skeleton
                active
                paragraph={{ rows: 1 }}
                title={false}
                style={{ backgroundColor: '#ffffff33' }}
              />
            </div>
          </div>

        ) : (
          <Card
            bordered={false}
            bodyStyle={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #36c6d3, #43e97b)',
              borderRadius: 16,
              color: '#fff',
              boxShadow: '0 8px 20px rgba(54, 198, 211, 0.35)',
            }}
          >
            <>
              <Row justify="space-between" align="middle" style={{ flexWrap: 'nowrap' }}>
                <Col style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 800,
                      color: '#fff',
                    }}
                  >
                    Dashboard Update Available
                  </div>
                </Col>

                <Col>
                  <Button
                    shape="circle"
                    icon={<CloseCircleOutlined style={{ fontSize: 18 }} />}
                    size="small"
                    onClick={handleToggleCardView}
                    style={{
                      backgroundColor: 'transparent',
                      color: '#fff',
                      border: 'none',
                      transition: 'all 0.3s ease-in-out',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = '#ff4d4f';
                      e.currentTarget.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = '#fff';
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  />
                </Col>
              </Row>

              <div
                style={{
                  width: '100%',
                  height: 1,
                  background: 'rgba(255, 255, 255, 0.4)',
                  margin: '10px 0',
                }}
              />

              <Space direction="vertical" style={{ width: '100%' }} size="middle">
                <Row
                  justify="left"
                  align="middle"
                  style={{
                    borderRadius: 10,
                    padding: '0px 0px',
                    cursor: 'pointer',
                    textAlign: "left",
                    width: "100%"
                  }}
                >
                  <div
                    style={{ color: '#fff', fontWeight: 500, fontSize: 15 }}
                    onClick={() => handleDismissAll(allUids)}
                  >
                    We’ve just rolled out some new improvements to your dashboard.
                    You can click to explore the update now, or check it later anytime from the Help Center section.
                  </div>
                </Row>
              </Space>
            </>
          </Card>
        )
      )}
    </div>
  );

};

export default GlobalUpdateNotifier;
